var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoResultsFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108.7,
    height: 94.95,
    viewBox: "0 0 108.7 94.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6679",
    "data-name": "Group 6679",
    transform: "translate(-210 -1592)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4784",
    "data-name": "Rectangle 4784",
    width: 72,
    height: 62,
    rx: 7,
    transform: "translate(210 1592)",
    fill: "#e6ebf4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4785",
    "data-name": "Rectangle 4785",
    width: 24,
    height: 13,
    rx: 6.5,
    transform: "translate(290 1592)",
    fill: "#e6ebf4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4786",
    "data-name": "Rectangle 4786",
    width: 24,
    height: 13,
    rx: 6.5,
    transform: "translate(210 1662)",
    fill: "#e6ebf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3653",
    "data-name": "Path 3653",
    d: "M-5097,918l31.785,31.785",
    transform: "translate(5378.965 732.215)",
    fill: "none",
    stroke: "#7e9dae",
    strokeLinecap: "round",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_252",
    "data-name": "Ellipse 252",
    transform: "translate(256.25 1624.5)",
    fill: "#fff",
    stroke: "#7e9dae",
    strokeWidth: 7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 25.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 22,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResultsFound);
export default __webpack_public_path__ + "static/media/no-results-found.e54632313cc99c65f62cd03d1a600d4b.svg";
export { ForwardRef as ReactComponent };